import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { LOGO_MANFRED_WHITE } from 'utils/logos';
import {
  StyledCard,
  StyledContent,
  StyledDate,
  StyledEmptyThumb,
  StyledExcerpt,
  StyledThumb,
  StyledTitle
} from './BlogCard.styled';

export type TeamCardProps = {
  url: string;
  title: string;
  thumb?: string;
  date: string;
  excerpt: string;
};

const BlogCard: React.FC<TeamCardProps> = ({
  url,
  title,
  thumb,
  date,
  excerpt
}) => {
  const { locale } = useRouter();

  return (
    <Link href={`${getAppUrl(APP_URLS.blog, locale)}/${url}`} passHref>
      <StyledCard>
        <StyledThumb>
          {thumb && <img src={thumb} alt="" />}
          {!thumb && (
            <StyledEmptyThumb>
              <img src={LOGO_MANFRED_WHITE} alt="" />
            </StyledEmptyThumb>
          )}
        </StyledThumb>
        <StyledContent>
          <StyledDate>
            {new Date(date).toLocaleDateString(locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </StyledDate>
          <StyledTitle>{title}</StyledTitle>
          <StyledExcerpt>
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt
              }}
            ></div>
          </StyledExcerpt>
        </StyledContent>
      </StyledCard>
    </Link>
  );
};

export default BlogCard;
